export default __webpack_public_path__ + "static/media/lgn-tablet-main.4bbc82cc.webp";